import React from 'react'
import "./works.css"
import CSharpTechStack1 from "../../resources/CSharp_techStack_1.png"
import DotnetTechStack2 from "../../resources/DotNet_techStack_2.png"
import SeleniumTechStack3 from "../../resources/Selenium_techStack_3.png"
import ReactJsTechStack4 from "../../resources/ReactJs_techStack_4.png"
import JavaTechStack5 from "../../resources/Java_techStack_5.png"
import JMeterTechStack6 from "../../resources/JMeter_techStack_6.png"
import AWS from "../../resources/aws_as_skill.png"
import SQL from "../../resources/SQL.png"
import Docker from "../../resources/docker.png"
import Azure from "../../resources/azure.png"
import RobotFramework from "../../resources/robot-framework-logo.jpg"

const Works = () => {
    return (
    <section id='works'>
        <h2 className='worksTitle'> Tech Stacks </h2>
        <span className='worksDesc'>As a passionate software developer and a QA professional, below are the tech stacks I have previously worked on.</span>
        <div className='worksImgs'>
            <img src={CSharpTechStack1} alt='' className='worksImg' />
            <img src={DotnetTechStack2} alt='' className='worksImg' />
            <img src={AWS} alt='' className='worksImg' />
            <img src={SeleniumTechStack3} alt='' className='worksImg' />
            <img src={ReactJsTechStack4} alt='' className='worksImg' />
            <img src={JavaTechStack5} alt='' className='worksImg' />
            <img src={SQL} alt='' className='worksImg' />
            <img src={Docker} alt='' className='worksImg' />
            <img src={JMeterTechStack6} alt='' className='worksImg' />
            <img src={Azure} alt='' className='worksImg' />
            <img src={RobotFramework} alt='' className='worksImg' />
        </div>
    </section>
    );
}

export default Works